var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"textTip"},[_c('i',{staticClass:"el-icon-warning icon-warning-class"}),_c('div',{staticClass:"tipContent"},[_vm._t("default")],2),_c('i',{staticClass:"el-icon-close icon-close-class",on:{"click":_vm.closeTip}})])}
var staticRenderFns = []

export { render, staticRenderFns }